import { TableCell, TableSortLabel } from "@material-ui/core";
import React, { useCallback } from "react";

import { SortDirection } from "../enums/SortDirection";
import { SortInfo } from "../rest/requestObjects/SortInfo";

const MuiSortDirectionMap = {
    [SortDirection.Ascending]: "asc" as const,
    [SortDirection.Descending]: "desc" as const,
};

interface Props {
    label: string;
    sortKey: string;
    sortInfo: SortInfo | undefined;
    setSortInfo: (sortInfo: SortInfo) => void;
}

export function TableCellWithSort({
    label,
    sortKey,
    sortInfo,
    setSortInfo,
}: Props) {
    const isActive = sortInfo && sortKey === sortInfo.sortBy;

    const onSortDirectionChange = useCallback(() => {
        setSortInfo({
            sortBy: sortKey,
            sortDirection: isActive && sortInfo!.sortDirection === SortDirection.Descending
                ? SortDirection.Ascending
                : SortDirection.Descending,
        });
    }, [sortInfo, setSortInfo, sortKey, isActive]);


    return (
        <TableCell
            align="left"
            sortDirection={isActive ? MuiSortDirectionMap[sortInfo!.sortDirection] : false}
        >
            <TableSortLabel
                active={isActive}
                direction={isActive ? MuiSortDirectionMap[sortInfo!.sortDirection] : "desc"}
                onClick={onSortDirectionChange}
            >
                {label}
            </TableSortLabel>
        </TableCell>
    );
}
